
/**
 * GetInspecaoPatrimonioItensByIdUseCase
 */

import { IGetInspecaoPatrimonioItensByIdUseCase } from "../../../presentation/useCases/read/get_inspecao_patrimonio_itens_by_id_use_case";
import { InspecaoPatrimonioItensModel } from "../../models/Inspecao_patrimonio_itens";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class GetInspecaoPatrimonioItensByIdUseCase implements IGetInspecaoPatrimonioItensByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getInspecaoPatrimonioItensById(
    idInspecaoPatrimonioItens: number,
  ): Promise<InspecaoPatrimonioItensModel> {
    return await this.repository.getInspecaoPatrimonioItensById(idInspecaoPatrimonioItens);
  }
}
